import { c as _c } from "react/compiler-runtime";
import { Button } from '@xefi/x-react/button';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import empty from '@/assets/lottie/empty.json';
const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false
});
export const EmptySurveyState = () => {
  const $ = _c(8);
  const {
    t
  } = useTranslation();
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      router.push("/new");
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleCreateSurvey = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Lottie animationData={empty} loop={true} className="size-[200px]" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("survey.create.new");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleCreateSurvey || $[6] !== t2) {
    t3 = <div className="flex h-[50vh] flex-col items-center justify-center">{t1}<Button onClick={handleCreateSurvey}>{t2}</Button></div>;
    $[5] = handleCreateSurvey;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};